import React, { useEffect, useState } from "react";
import { GetBankDetails, Insertbankdetails } from "../../services/dataService";
import toast from "react-hot-toast";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getSecureItem } from "../../services/SecureStorage";
function BankDetails({ EmpId, onClose }) {
  const [loading, setLoading] = useState(false);
  const UID = getSecureItem("userId");
  const [isEdit, SetIsEdit] = useState(true)

  const [bankDetails, setBankDetails] = useState({
    BankName: "",
    AccNo: "",
    BranchName: "",
    IFSC: "",
    EmpId: "",
    NomineeName: "",
    UserId: UID,

  });
  const handleInputChangesBank = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const ClearBankDetails = () => {
    setBankDetails({
      BankName: "",
      AccNo: "",
      BranchName: "",
      IFSC: "",
      NomineeName: "",
    });
  };
  const handleBankDetailsSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const payloadWithEmpID = {
        ...bankDetails,
        EmpId: EmpId,
        UserId: UID,
        Id: bankDetails?.BankDetailsId || ''
      };

      const response = await Insertbankdetails(payloadWithEmpID);
      if (response.data.StatusCode === 200) {
        toast.success(response.data.message);
        onClose()
      }
    } catch (error) {
      toast.error("Failed to Bank Details ");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true)
    const getPersonal = async () => {
      try {
        const response = await GetBankDetails(UID);

        if (response?.data) {
          const data = response.data.data.find(
            (el) => el.EmployeeId === EmpId
          ); // Match EmpId with UID
          setLoading(false)
          if (data) {
            setBankDetails(data);

          } else {
            console.warn(
              "No personal details found for the given employee ID."
            );
          }
        } else {
          console.warn("Response data is empty or undefined.");
        }
      } catch (error) {
        console.error("Error fetching personal details:", error);
      }
    };

    getPersonal();
  }, [UID, setBankDetails, EmpId]);
  if (loading) {
    return (
      <div className="skeleton-container">
        {[...Array(2)].map((_, rowIndex) => (
          <div className="skeleton-row" key={rowIndex} style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)', // 2 columns
            gap: '1rem',
            marginBottom: '1rem'
          }}>
            <Skeleton height={50} width="100%" />
            <Skeleton height={50} width="100%" />
          </div>
        ))}
      </div>
    );
  }
  const handleIsEdit = () => {
    SetIsEdit(!isEdit); // Toggles the value of isEdit
  };



  return (
    <div>
      {" "}
      <form onSubmit={handleBankDetailsSubmit}>
        <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
          <div className="flex justify-end">
            <button
              className="btn btn-success"
              type="button"
              onClick={handleIsEdit}
            >
              {isEdit ? 'Enable Edit Mode' : 'Disable Edit Mode'}
            </button>
          </div>
          <div className="grid grid-cols-12 gap-20">
            <>
              <div className="form-group col-span-6">
                <label>
                  Bank Name <span style={{ color: "red" }}>*</span>
                </label>
                <textarea
                  disabled={isEdit}
                  name="BankName"
                  value={bankDetails.BankName}
                  onChange={handleInputChangesBank}
                  placeholder="Bank Name"
                  className="w-full"
                  required
                />
              </div>

              <div className="form-group col-span-6">
                <label>
                  Account Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={isEdit}

                  type="number"
                  name="AccNo"
                  onChange={handleInputChangesBank}
                  value={bankDetails.AccNo}
                  placeholder="Account Number"
                  required
                />
              </div>

              <div className="form-group col-span-6">
                <label>
                  Branch Name
                </label>
                <input
                  disabled={isEdit}

                  type="text"
                  name="BranchName"
                  value={bankDetails?.BranchName}
                  onChange={handleInputChangesBank}
                  placeholder="Branch Name"
                />
              </div>

              <div className="form-group col-span-6">
                <label>
                  IFSC Code <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  disabled={isEdit}

                  type="Text"
                  name="IFSC"
                  value={bankDetails?.IFSC}
                  onChange={handleInputChangesBank}
                  placeholder="IFSC Code"
                  className="form-control"
                  required
                  onBlur={(e) => {
                    handleInputChangesBank({ target: { name: "IFSC", value: e.target.value.trim() } });
                  }}
                />
              </div>

              <div className="form-group col-span-6">
                <label>
                  Nominee Name
                </label>
                <input
                  disabled={isEdit}

                  type="text"
                  name="NomineeName"
                  value={bankDetails?.NomineeName}
                  onChange={handleInputChangesBank}
                  placeholder="Enter Nominee Name"
                  className="form-control"
                />

              </div>
            </>
          </div>
        </div>

        <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
          <button
          disabled={isEdit}
            type="button"
            onClick={ClearBankDetails}
            className="btn btn-outline-secondary"
          >
            Clear
          </button>
          <button disabled={isEdit} type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default BankDetails;
